import api from '../../services/api'
import {
  CHANNEL_TABLE,
  CHANNEL_IS_FETCHING,
  CHANNEL_IS_FETCHING_ID,
  CHANNEL_SUCCESS,
  CHANNEL_CREATE,
  CHANNEL_UPDATE,
  CHANNEL_SELECT,
  CHANNEL_SELECT_DIRECTORY,
  CHANNEL_EDIT_DIRECTORY,
  CHANNEL_SELECT_PREVIOUS_DIRECTORY,
  CHANNEL_ADD_USERS,
  CHANNEL_DELETE_USERS,
  CHANNEL_ADD_GROUPS,
  CHANNEL_DELETE_GROUPS
} from '../types'

function getChannels () {
  return (dispatch) => {
    dispatch(isFetching(CHANNEL_IS_FETCHING, true))

    api.channel.getChannels().then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_SUCCESS,
          payload: response.data.result
        })
      }
    }).then(() => {
      dispatch(isFetching(CHANNEL_IS_FETCHING, false))
    })
  }
}

function getChannelById (id) {
  return (dispatch) => {
    dispatch(isFetching(CHANNEL_IS_FETCHING_ID, true))

    return api.channel.getChannelById(id).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_SELECT,
          payload: response.data.result
        })
      }
      return response
    }).then(() => {
      dispatch(isFetching(CHANNEL_IS_FETCHING_ID, false))
    })
  }
}

function createChannel (params) {
  return (dispatch) => {
    return api.channel.createChannel(params).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_CREATE,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

function updateChannelById (id, params) {
  return (dispatch) => {
    return api.channel.updateChannelById(id, params).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_UPDATE,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

function selectDirectory (object) {
  return (dispatch) => {
    dispatch({
      type: CHANNEL_SELECT_DIRECTORY,
      payload: object
    })
  }
}

function toPreviousPage (id) {
  return (dispatch) => {
    return api.storage.getStorageById(id).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_SELECT_PREVIOUS_DIRECTORY,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

function clearSelectedChannel () {
  return (dispatch) => {
    dispatch({
      type: CHANNEL_SELECT,
      payload: {
        dirs: [],
        files: []
      }
    })
  }
}

function isFetching (type, payload) {
  return {
    type,
    payload
  }
}

function updateTable (payload) {
  return {
    type: CHANNEL_TABLE,
    payload
  }
}

function addUsers (id, array) {
  return (dispatch) => {
    return api.channel.addUsers(id, array).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_ADD_USERS,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

function deleteUsers (id, array) {
  return (dispatch) => {
    return api.channel.deleteUsers(id, array).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_DELETE_USERS,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

function addGroups (id, array) {
  return (dispatch) => {
    return api.channel.addGroups(id, array).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_ADD_GROUPS,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

function deleteGroups (id, array) {
  return (dispatch) => {
    return api.channel.deleteGroups(id, array).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_DELETE_GROUPS,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

function editDirectory (id, name) {
  return (dispatch) => {
    return api.storage.updateStorageFileById(id, { name: name }).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_EDIT_DIRECTORY,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

function lock (id) {
  return (dispatch) => {
    dispatch(isFetching(CHANNEL_IS_FETCHING_ID, true))

    return api.channel.lock(id).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_SELECT,
          payload: response.data.result
        })
      }
      return response
    }).then(() => {
      dispatch(isFetching(CHANNEL_IS_FETCHING_ID, false))
    })
  }
}

function unlock (id) {
  return (dispatch) => {
    dispatch(isFetching(CHANNEL_IS_FETCHING_ID, true))

    return api.channel.unlock(id).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_SELECT,
          payload: response.data.result
        })
      }
      return response
    }).then(() => {
      dispatch(isFetching(CHANNEL_IS_FETCHING_ID, false))
    })
  }
}

export {
  getChannels,
  createChannel,
  getChannelById,
  selectDirectory,
  editDirectory,
  toPreviousPage,
  updateTable,
  updateChannelById,
  clearSelectedChannel,

  addUsers,
  deleteUsers,
  addGroups,
  deleteGroups,

  lock,
  unlock
}



// WEBPACK FOOTER //
// ./src/store/actions/channel.js